import { render } from "./LinkPage.vue?vue&type=template&id=61d73ea3&scoped=true"
const script = {}

import "./LinkPage.vue?vue&type=style&index=0&id=61d73ea3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d73ea3"]])

export default __exports__